/*
 * File: BillingPreferences.js
 * Project: mp-mobile-app
 *
 * Created by Dillon Neukirch on 06/08/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Model for creating Billing preferences list on Preferences page
 */
const BillingPreferences = [
  {
    label: "Billing Order",
    type: "header"
  },
  {
    name: "allowDx",
    label: "Allow Diagnosis Codes",
    type: "switch",
    value: false
  },
  {
    name: "allowModifiers",
    label: "Allow Modifiers",
    type: "switch",
    value: false
  },
  {
    name: "allowToothSurface",
    label: "Allow Tooth and Surface",
    type: "switch",
    value: false
  }
];

export default BillingPreferences;
